// extracted by mini-css-extract-plugin
export default {"goforisrael-btn":"goforisrael-btn--EeRvz","goforisraelBtn":"goforisrael-btn--EeRvz","blink":"blink--gi0vS"};